export default __webpack_public_path__ + "static/media/logo-scratchpay-text-blue.f2b8cdc6.png";